import { useDisclosure } from "@mantine/hooks";

export const useHelpRequest = () => {
  const [opened, { open: open, close: close }] = useDisclosure();
  return { openedHelpRequest: opened, openHelpRequest: open, closeHelpRequest: close };
};
